import React from 'react';
import { PageHeaderWithTabs, MasterLayoutMiddle, FooterInner, } from "@dclab/dc-react-ui-kit";
import JanazahDetailsPage from './JanazahDetailsPage';
import DeceasedDetails from './DeceasedDetails'
import GraveDetails from './GraveDetails';


function Pages(props) {

  const style = {
    width: '101%',
  };

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    console.log(event, newValue);
  };
  const object = [
    {
      label: "JANAZAH DETAILS",
    },
    {
      label: "DECEASED DETAILS",
    },
    {
      label: "GRAVE DETAILS",
    },
  ];




  return (

    <MasterLayoutMiddle
      header={
        <PageHeaderWithTabs
          back={() => props.history.push("/website/pages")}
          value={value}
          title="Hassan Ahmed"
          object={object}
          style={{ color: "#2A82F6", border: "1px solid black" }}
          handleChange={(x, y) => handleChange(x, y)}
          indicatorColor="#2A82F6"
          hiddenDraft={true}
          hiddenPublish={true}
          btnText="Back"
        />
      }
      content={
        <div>
          {value === 0 && (
            <JanazahDetailsPage />
          )}

          {value === 1 && (
            <DeceasedDetails />
          )}

          {value === 2 && (
            <GraveDetails />
          )}
        </div>
      }
      isFooter={true}
      footer={
        <FooterInner
          style={style}
          termsLink={process.env.REACT_APP_Environment === 'dev' ? "http://shapla.deenconnect.io/terms-policies" : "http://deenconnect.io/terms-policies"}
          privacyLink={process.env.REACT_APP_Environment === 'dev' ? "http://shapla.deenconnect.io/terms-policies#privacy-policy" : "http://deenconnect.io/terms-policies#privacy-policy"}
        />
      }
      isWhiteBackground={false}
    />

  );
}


export default Pages;